import { render } from "./MainTable.vue?vue&type=template&id=bb75a5c6&scoped=true"
import script from "./MainTable.vue?vue&type=script&lang=js"
export * from "./MainTable.vue?vue&type=script&lang=js"

import "./MainTable.vue?vue&type=style&index=0&id=bb75a5c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb75a5c6"]])

export default __exports__